import './index.css';
// Configure Monaco loader to use CDN (loader.config only — no init/download until an Editor mounts)
import '@/lib/monaco-loader';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/components/ui/resizable';
import { Toaster } from '@/components/ui/sonner';
import AppInitializer from '@/app/components/common/AppInitializer';
import { ThemeProvider } from '@/app/components/common/theme-provider';
import BackendStatusWrapper from '@/app/components/common/BackendStatusWrapper';
import { AuthGate } from '@/app/components/auth/AuthGate';
import CurrentSessionPage from '@/app/components/session/CurrentSessionPage';
import MainHomePage from '@/app/components/pages/MainHomePage';

function App() {
  return (
    <div className="font-sans antialiased h-screen overflow-hidden">
      <ThemeProvider>
        <BackendStatusWrapper>
          <AuthGate>
            <ResizablePanelGroup
              direction="horizontal"
              className="w-full h-full"
            >
              <ResizablePanel defaultSize={70}>
                {/* Main Container */}
                <main className="h-full bg-background p-2 overflow-y-auto">
                  <MainHomePage />
                </main>
              </ResizablePanel>
              <ResizableHandle withHandle />
              <ResizablePanel defaultSize={30} minSize={25} maxSize={45}>
                {/* Side Container */}
                <div className="h-full bg-slate-50 dark:bg-slate-900/50 flex flex-col">
                  <CurrentSessionPage />
                </div>
              </ResizablePanel>
            </ResizablePanelGroup>
            <AppInitializer />
          </AuthGate>
          <Toaster richColors closeButton position="bottom-left" />
        </BackendStatusWrapper>
      </ThemeProvider>
    </div>
  );
}

export default App;